import React, { useState } from 'react';
import PropTypes from 'prop-types';
// @mui
//
import Iconify from '../Iconify';
import { MenuItem, Divider } from '@mui/material';
import { TableMoreMenu } from '../table';
// ----------------------------------------------------------------------
MoreMenu.propTypes = {
  actions: PropTypes.node,
  open: PropTypes.object,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  icon: PropTypes.string
};
MoreMenu.defaultProps = {
  icon: 'eva:more-vertical-fill'
};
export default function MoreMenu({ onEditingMarkAsPaid, onDeleteMarkAsPaid }) {
  const [openMenu, setOpenMenuActions] = useState(null);
  const handleOpenMenu = (event) => {
    setOpenMenuActions(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };
  return (
    <>
      <TableMoreMenu
        open={openMenu}
        onOpen={handleOpenMenu}
        onClose={handleCloseMenu}
        icon="eva:more-horizontal-fill"
        actions={
          <div>
            <MenuItem onClick={onEditingMarkAsPaid}>
              <Iconify icon={'eva:edit-fill'} />
              Edit
            </MenuItem>
            <Divider className="my-2" />
            <MenuItem onClick={onDeleteMarkAsPaid} sx={{ color: 'error.main' }}>
              <Iconify icon={'eva:trash-2-outline'} />
              Delete
            </MenuItem>
          </div>
        }
      />
    </>
  );
}
